module.exports = __webpack_public_path__ + "static/media/mbj_login.0f39e022.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/MyBabyJo/mbj_login.jpg
// module id = 691
// module chunks = 0